import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { JobBoardPost } from '@shared/models/job-board-post';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class JobBoardPostService extends ApiService<any> {

  constructor(http: HttpClient) {
    super(http);
    this.url = 'job-board-post';
  }

  updateJobBoardPostForJob(body: Partial<JobBoardPost>): Observable<JobBoardPost> {
    return this.post({ url: '', body });
  }

  getJobBoardsForJob(id: number): Observable<JobBoardPost[]> {
    return this.get({ url: `/${id}` });
  }
}
